import React, { useEffect } from "react"
import {
   Button,
   ButtonGroup,
   Card,
   Dropdown,
   Row,
   Col,
   Form,
   Table,
   Nav,
   Pagination,
} from "react-bootstrap"
// import Button,Form from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal"
import { fetchAPIData, isLoggedIn, notAuthorized, highlyConnectedMessage, EBPIDsForEmail } from "../../api/AuthService"
import { WHERE_USED, Highly_CONNECTED_API, EMAIL_DATA } from "../../constant/Constants"
import { addBreadCrumbLinks } from "../commonComponents/EventHandler"
import { Link, useNavigate } from "react-router-dom"
import { useState, useMemo } from "react"


export default function WhereUsedModal(props) {
   const navigate = useNavigate()
   const [results, setResults] = useState([])
   const [loading, setLoading] = useState(false)

   const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = useState(config)

      const sortedItems = useMemo(() => {
         let sortableItems = [...items]

         if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
               if (a[sortConfig.key].toLowerCase() < b[sortConfig.key].toLowerCase()) {
                  return sortConfig.direction === "ascending" ? -1 : 1
               }
               if (a[sortConfig.key].toLowerCase() > b[sortConfig.key].toLowerCase()) {
                  return sortConfig.direction === "ascending" ? 1 : -1
               }
               return 0
            })
         }
         return sortableItems
      }, [items, sortConfig])

      const requestSort = (key) => {
         let direction = "ascending"
         if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === "ascending"
         ) {
            direction = "descending"
         }
         setSortConfig({ key, direction })
      }
      return { items: sortedItems, requestSort, sortConfig }
   }
   const [resultsPerPage, setResultsPerPage] = useState(5)
   const [currentPage, setCurrentPage] = useState(1)
   const indexOfLastResult = currentPage * resultsPerPage
   const indexOfFirstResult = indexOfLastResult - resultsPerPage
   const { items, requestSort, sortConfig } = useSortableData(results)
   const currentResult = items.slice(indexOfFirstResult, indexOfLastResult)
   const [activePage, setActivePage] = useState(1)
   const [error, setError] = useState()
   const [message, setMessage] = useState("")
   
   const getClassNamesFor = (name) => {
      if (!sortConfig) {
         return "fa fa-sort"
      } else if (sortConfig.key === name) {
         if (sortConfig.direction === "ascending") {
            return "fa fa-caret-up"
         } else {
            return "fa fa-caret-down"
         }
      } else {
         return "fa fa-sort"
      }
   }

   function handlePageChange(pageNumber) {
      setCurrentPage(pageNumber)
      setActivePage(pageNumber)
   }

   const totalPages = Math.ceil(results.length / resultsPerPage)

   const renderPaginationItems = () => {
      const items = []
      const maxPagesToShow = 3
      let startPage = Math.max(1, activePage - Math.floor(maxPagesToShow / 2))
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

      if (endPage - startPage + 1 < maxPagesToShow) {
         startPage = Math.max(1, endPage - maxPagesToShow + 1)
      }

      if (activePage > 1) {
         items.push(
            <Pagination.First key="first" onClick={() => handlePageChange(1)} />,
            <Pagination.Prev key="prev" onClick={() => handlePageChange(activePage - 1)} />
         )
      }

      for (let page = startPage; page <= endPage; page++) {
         items.push(
            <Pagination.Item
               key={page}
               active={page === activePage}
               onClick={() => handlePageChange(page)}
            >
               {page}
            </Pagination.Item>
         )
      }

      if (activePage < totalPages) {
         items.push(
            <Pagination.Next key="next" onClick={() => handlePageChange(activePage + 1)} />,
            <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
         )
      }

      return items
   }

   const fetchData1 = async () => {
      try {
         setLoading(true)
         const response = await fetchAPIData(`${WHERE_USED}/${props.objectid}`)

         if(response.data.highlyConnectedParts !== ""){
            setMessage(response.data.highlyConnectedParts)
         }

         if (response.data ) {
            setResults(response.data.ImpactedParts)
            setLoading(false)
            setError(0)

         }
         else {
            setLoading(false)
            setError(1)
         }
      } catch (error) {
         if (error.response && error.response.status === 408) {
            setLoading(false)
            setError(3)
         }
         else {
            setLoading(false)
            setError(2)
         }
      }
      console.log("error", error)

   }

   const fetchTOandCC = async (ids) => {
      const data = {
         objectId: Array.isArray(ids) ? ids : [ids]
      }
      try {
         const response = await EBPIDsForEmail(`${EMAIL_DATA}`, data)
         if (response.data) {
            return { To: response.data.To, CC: response.data.CC }
         }
         return null
      } catch (error) {
         console.error("API error", error)
         return null
      }
   }

   async function highlyConnectedMessageFunction() {
      const path = window.location.pathname;
      const objectId = path.split('/').pop();
      const ToandCCData = await fetchTOandCC(objectId)
      const fullName = localStorage.getItem("User");
      const userName = localStorage.getItem("UserId");
      const role = localStorage.getItem("role");
      const employee = localStorage.getItem("employee") ? atob(localStorage.getItem("employee")) : null;
      const hir_compliant = localStorage.getItem("hir_compliant");
      const data = {
         userRole: role != "" ? role : employee,
         plantName: "",
         partName: props.name,
         userName: userName,
         to: ToandCCData.To.join(","),
         cc: ToandCCData.CC.join(","),
         fullName: fullName,
         hir_compliant: hir_compliant ? hir_compliant : ""
      }
      highlyConnectedMessage(`${Highly_CONNECTED_API}`, data)
         .then((response) => {
            if (response.data) {
               alert("Email sent successfully.")
            }
         })
         .catch((error) => {
            alert("There is an issue with the search service. Please contact SpecReaderExt.im@pg.com for help.")
            if (error.response && error.response.status) {
               console.log(error.response.status, error.response.data.message)
            } else {
               console.log(1000, error)
            }
         })
   }


   const impacted_content =
      currentResult && currentResult.length ? (
         currentResult.map((key, index) => (
            <tr key={index}>
               <td width="10%">
                  {key.link != null && key.id != null ? (
                     <Link
                        target="_blank"
                        rel="noreferrer noopener"
                        className="impacted-part-link"
                        onClick={() =>
                           addBreadCrumbLinks(
                              key.Name,
                              `/${key.link.toUpperCase().trim()}/${key.id.trim()}`
                           )
                        }
                        to={(location) => ({
                           ...location,
                           pathname: `/${key.link.toUpperCase()}/${key.id}`,
                        })}
                        
                     >
                        <span textalign="left">{key.Name}</span>
                     </Link>
                  ) : (
                     <span>{key.Name}</span>
                  )}
               </td>
               <td align="left" width="10%">
                  {key.DisplayType}
               </td>
               <td align="left" width="5%">
                  {key.Revision}
               </td>
               <td align="left" width="10%">
                  {key.Title}
               </td>
            </tr>
         ))) : (
         <tr>
            <td align="left" width="10%">
               {""}
            </td>
            <td align="left" width="10%">
               {""}
            </td>
            <td align="left" width="5%">
               {""}
            </td>
            <td align="left" width="10%">
               {""}
            </td>
         </tr>
      )

   useEffect(() => {
      if (!isLoggedIn()) {
         navigate("/")
      } else if (props.show) {
         document.body.style.overflow = 'hidden'
         fetchData1()
      }
      document.body.style.overflow = 'unset'
   }, [props.show, navigate])

   return (
      <Modal
         {...props}
         show={props.show}
         aria-labelledby="contained-modal-title-vcenter"
         centered
         dialogClassName="my-modal"
         style={{ overflowY: "hidden" }}
         backdrop="static"
         keyboard={false}
      >
         <Modal.Header closeButton onHide={props.onHide}>
            <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
            <div className="reportLabels2 mt-20" style={{ marginTop: "5px", fontFamily: "var(--app-font-family)" }}>Where Used - {props.name} {props.Rev} </div>
         </Modal.Header>
         <Modal.Body>
            <Form>
               <Row style={{ height: "450px" }}>
                  <Col md="3" sm="3">
                     <Card
                        autoFocus
                        style={{
                           backgroundColor: "#003daf",
                           color: "white",
                           height: "410px",
                           fontSize: "13px",
                           fontweight: "bold",
                           fontFamily: "var(--app-font-family)",
                        }}
                     >
                        <Card.Body>Name : {props.name} <br></br>
                           Revision : {props.Rev}  <br></br>
                           <div className="sideNavButton1" style={{ marginTop: "20px" }}>
                              <i className="fa fa-angle-right"></i> &nbsp;Where Used
                           </div>
                        </Card.Body>
                     </Card>
                  </Col>
                  <Col md="9" sm="9" style={{ fontFamily: "var(--app-font-family)" }}>
                     {loading ? (
                        <h2 style={{ textAlign: "center", color: "#0173d4" }}>
                           <i
                              className="fa fa-spinner fa-spin"
                              style={{ marginRight: "5px" }}
                           />
                           Loading........
                        </h2>
                     ) : (
                        <React.Fragment>
                           
                              <React.Fragment>
                                 {message != "" && (
                                    <div>
                                       <p className="alertMsg1">
                                          {" "}
                                          This is a highly connected part. There could be other Enterprise Parts connected.
                                          &nbsp;
                                          <a
                                             href="#"
                                             onClick={e => { e.preventDefault(); highlyConnectedMessageFunction(); }}
                                             style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                                          >
                                             Click here to get data on email.
                                          </a>
                                       </p>
                                    </div>)}
                                 
                                 {error ===0 && (<div>
                                 
                                 <div style={{ width: "100%", marginBottom: "30px" }} id="paginTab">
                                    <Pagination>{renderPaginationItems()}</Pagination>
                                 </div>
                                 <br />
                                 <div style={{ marginBottom: "20px" }}>
                                    <span style={{ fontSize: "15px" }}><span style={{ fontWeight: "bold" }}>Name:</span> {props.name}&nbsp;&nbsp;</span>
                                    <span style={{ fontSize: "15px" }}><span style={{ fontWeight: "bold" }}>Revision:</span> {props.Rev}</span>
                                 </div>
                                 <div className="Modalheading">Where Used</div>
                                 <div style={{ overflow: "auto", flex: 1, height: "280px" }}>
                                    <Table bordered className="where-used-table" style={{ height: "200px" }}>
                                       <thead style={{ position: "sticky", top: -1, color: "Black", backgroundColor: "White" }}>
                                          <tr>
                                             <th width="20%">
                                                Impacted Part(s)&nbsp;
                                                <i
                                                   onClick={() => requestSort("Name")}
                                                   className={getClassNamesFor("Name")}
                                                ></i>
                                             </th>
                                             <th width="20%">
                                                Type &nbsp;

                                             </th>
                                             <th width="10%">
                                                Rev &nbsp;

                                             </th>
                                             <th width="30%">Title &nbsp;</th>
                                          </tr>

                                       </thead>
                                       <tbody>{impacted_content}</tbody>
                                    </Table>
                                    </div>
                                 </div>)}
                              </React.Fragment>
                           {error === 1 && (
                              <Form.Group as={Row}>
                                 <Form.Label column md="12" className="reportLabels1 mt-20" align="center" >
                                    No Results Found
                                 </Form.Label>
                              </Form.Group>
                           )}
                           {error === 2 &&
                              <Form.Group as={Row}>
                                 <Form.Label column md="12" className="reportLabels1 mt-20" align="center" style={{ color: "#a00505" }}>
                                    Search service issue. Please contact SpecReaderExt.im@pg.com for help.
                                 </Form.Label>
                              </Form.Group>
                           }
                           {error === 3 &&
                              <Form.Group as={Row}>
                                 <Form.Label column md="12" className="reportLabels1 mt-20" align="center" style={{ color: "#a00505" }}>
                                    This is a highly connected part. There could be other Enterprise Parts connected.
                                    &nbsp;
                                    <a
                                       href="#"
                                       onClick={e => { e.preventDefault(); highlyConnectedMessageFunction(); }}
                                       style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                       Click here to get data on email.
                                    </a>
                                 </Form.Label>
                              </Form.Group>
                           }
                        </React.Fragment>)}

                  </Col>


               </Row>
               <br />
            </Form>

         </Modal.Body>
      </Modal>
   )
}